//the main page for property/complex (shown to BD only), recommend adding assets in here
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Typography,
} from "@mui/material";
import {
  DetailsColumn,
  DetailsContainer,
  MainContainer,
  TopBarContainedBrandButton,
  TopBarContainer,
} from "../constants/component.constants";
import { useEffect, useState } from "react";
import {
  deleteUnit,
  exportProperties,
  getFacility,
  getFacilityMeters,
  getFacilityUnits,
} from "../services/property.service";
import { useSelector } from "react-redux";
import Permit from "../util/permit";
import {
  formatCurrency,
  isEmptyObject,
  isEmptyString,
  isNullUndefined,
  sortAlphaNum,
  tryParseInt,
} from "../util/util";
import Inspections from "../components/modals/inspections";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Delete, Edit, NoteAdd, Visibility } from "@mui/icons-material";
import { ResponsiveRow } from "../constants/layout.constants";
import ViewInspections from "../components/modals/viewInspections";
import PropertyModal from "../components/modals/rentals/properties/propertyModal";
import SplitButton from "../components/splitButton";
import UnitModal from "../components/modals/rentals/properties/unitModal";
import { issueResponseMessage } from "../actions/message";
import ConfirmationModal from "../components/modals/confirmation";
import {
  listPropertyInspection,
  listUnitInspection,
} from "../services/inspections.service";
import MuiDataGrid from "../components/modules/MuiDataGrid";
import { useNavigate } from "react-router-dom";
import kodi_theme from "../themes/kodiThemeProvider";
import PropertySubscriptionServiceItem from "../components/modals/rentals/properties/propertySubscriptionServiceItem";
import { fetchSubscription } from "../services/subscription.service";
import CourtModal from "../components/modals/rentals/properties/courtModal";
import { deleteCourt, getFacilityCourts } from "../services/courts.service";
import ViewCourtModal from "../components/modals/rentals/properties/viewCourt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//TODO: Look at this componenet in detail. There may be multipleloads of
// units and meters in theri own call and in the facility call

export default function Property() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [InspectModal, setInspectModal] = useState(false);
  const [ViewModal, setViewModal] = useState(false);
  const [facilityUnits, setFacilityUnits] = useState([]);

  const [meters, setMeters] = useState([]);
  const [inspect, setInspect] = useState("");
  const [contract, setContract] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedMeter, setSelectedMeter] = useState(null);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [task, setTask] = useState("");
  const user = useSelector((state) => state.auth.user);
  const [pageNo] = useState(0);
  const [unitModal, setUnitModal] = useState(false);
  const [courtModal, setCourtModal] = useState(false);
  const [propertyModal, setPropertyModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [titleText, setTitleText] = useState("");
  const [severityText, setSeverityText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [positiveText, setPositiveText] = useState("");
  const [negativeText, setNegativeText] = useState("");
  const [selectionModel, setSelectionModel] = useState([]);
  const [inspectionRecords, setInspectionRecords] = useState([]);
  const [subscription, setSubscription] = useState();
  const [courts, setCourts] = useState([]);
  const [courtViewOpen, setCourtViewOpen] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(false);

  const propertyButtons = [
    {
      label: "PROPERTY ACTIONS",
      roles: false,
      services: false,
    },
    {
      action: handleAddPropertyClick,
      label: "Add Property",
      roles: "BLDIR,SYSAD",
      services: "PREMIUM,HOA,CORE,LEAN,MAINT,METER",
    },
    {
      action: handleEditPropertyClick,
      label: "Edit Property",
      roles: "BLDIR,SYSAD",
      services: "PREMIUM,HOA,CORE,LEAN,METER,MAINT,BLWTR",
    },
    {
      action: exportProperty,
      label: "Export Property",
      roles: "BLDIR,BLDMG,SYSAD,CS",
      services: "PREMIUM,HOA,CORE,LEAN,MAINT",
    },
  ];

  const courtButtons = [
    {
      label: "COURT ACTIONS",
      roles: false,
      services: false,
    },
    {
      action: handleAddCourtClick,
      label: "Add Court",
      roles: "BLDIR,SYSAD",
      services: "PREMIUM,HOA,CORE,LEAN,MAINT",
    },
  ];

  const unitsButtons = [
    {
      label: "UNIT ACTIONS",
      roles: false,
      services: false,
    },
    {
      action: handleAddUnitClick,
      label: "Add Unit",
      roles: "BLDIR,SYSAD",
      services: "PREMIUM,HOA,CORE,LEAN,MAINT",
    },
  ];
  const inspectionButtons = [
    {
      label: "INSPECTION ACTIONS",
      roles: false,
      services: false,
    },
    {
      action: handleInspectPropertyClick,
      label: "Add Inspection record",
      roles: "BLDIR,SYSAD",
      services: "PREMIUM,HOA,CORE,MAINT",
    },
    {
      action: handleViewPropertyInspectionsClick,
      label: "View inspections",
      roles: "BLDIR,SYSAD",
      services: "PREMIUM,HOA,CORE,MAINT",
    },
  ];

  const hasUnitSubscription =
    user.services &&
    (user.services.includes("PREMIUM") ||
      user.services.includes("CORE") ||
      user.services.includes("LEAN") ||
      user.services.includes("HOA"));

  useEffect(() => {
    if (!unitModal && !courtModal && user.proxyFacility) {
      //reload the units on closing of the modal
      setLoading(true);
      const promises = [];
      promises.push(
        getFacilityUnits(user.proxyFacility, pageNo, false)
          .then((response) => {
            if (!isNullUndefined(response)) {
              setFacilityUnits(response.data);
            } else {
              navigate("/dashboard");
            }
          })
          .finally(() => {
            setSelectedUnit(null);
          }),
      );

      promises.push(
        getFacilityMeters(user.proxyFacility, pageNo, false)
          .then((response) => {
            if (!isNullUndefined(response)) {
              setMeters(response.data);
            } else {
              navigate("/dashboard");
            }
          })
          .finally(() => {
            setSelectedMeter(null);
          }),
      );

      promises.push(
        getFacilityCourts().then((response) => {
          setCourts(response);
        }),
      );

      Promise.all(promises).finally(setLoading(false));
    }
  }, [unitModal, courtModal, user.proxyFacility, pageNo, navigate]);

  useEffect(() => {
    if (user.proxyFacility) {
      setLoading(true);
      getFacility(user.proxyFacility)
        .then((facility) => {
          if (!isNullUndefined(facility) && !isNullUndefined(facility.units)) {
            setFacilityUnits(facility.units);
            setSelectedProperty(facility);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [user.proxyFacility]);

  useEffect(() => {
    if (user.proxyRole === "SYSAD" || user.proxyRole === "BLDIR") {
      fetchSubscription(user.proxySubscription).then((response) => {
        let data = response.data;
        setSubscription(data);
      });
    }
  }, [user.proxySubscription]);

  function exportProperty() {
    exportProperties();
  }

  const handleConfirmationClose = () => {
    setShowConfirmationModal(false);
    setSelectedUnit(null);
    setSelectedCourt(null);
    setTitleText("");
    setSeverityText("");
    setBodyText("");
    setPositiveText("");
    setNegativeText("");
  };

  function handleAddUnitClick() {
    //send an empty object
    setSelectedUnit({});
    setUnitModal(true);
  }

  function handleAddCourtClick() {
    setSelectedCourt({});
    setCourtModal(true);
  }

  const handleDeleteCourtModal = (court) => {
    // TODO: CHECK IF COURT HAS UNITS LINKED TO IT.
    setSelectedCourt(court);
    let title = "Confirm Delete Court '" + court.name + "'";
    let body = "Are you sure you want to permanently delete this court?";
    setTitleText(title);
    setTask("Delete Court");
    setSeverityText("warning");
    setBodyText(body);
    setPositiveText("Delete Court");
    setNegativeText("Cancel");
    setShowConfirmationModal(true);
  };

  function handleAddPropertyClick() {
    // let data = {
    //   id: null,
    //   name: "",
    //   description: "",
    //   latitude: "",
    //   longitude: "",
    //   lrNumber: "",
    //   units: [],
    //   workOrderRequest: false,
    //   address: {
    //     address1: "",
    //     address2: "",
    //     city: "",
    //     countryCd: "",
    //     fullAddress1: "",
    //     id: "",
    //   },
    //   facilityPayInfo: {
    //     mpesaKey: "",
    //     mpesaPassKey: "",
    //     mpesaSecret: "",
    //     mpesaPaybill: "",
    //     payInvoice: false,
    //     hideBalanceBroughtForward: false,
    //     mpesaBusinessShortcode: "",
    //     bankInfo: {
    //       id: "",
    //     },
    //   },
    // };
    // setSelectedProperty(data)
    setSelectedProperty({});
    setPropertyModal(true);
  }

  function handleEditPropertyClick() {
    // setSelectedProperty(property)
    setPropertyModal(true);
  }

  function handleInspectPropertyClick() {
    setInspectModal(true);
    setInspect("Property");
    setContract(selectedProperty);
    setTask("Inspect");
  }

  function handleViewPropertyInspectionsClick() {
    setViewModal(true);
    setInspect("Property");

    setContract(selectedProperty);
    listPropertyInspection(selectedProperty.id, new Date()).then(
      (inspectionRecords) => setInspectionRecords(inspectionRecords),
    );
  }

  function handleInspectUnitClick(unit) {
    setSelectedUnit(unit);
    setInspectModal(true);
    setInspect("Unit");
    setContract(unit);
    setTask("Inspect");
  }

  function handleViewUnitInspectionsClick(unit) {
    setSelectedUnit(unit);
    setViewModal(true);
    setInspect("Unit");
    setContract(unit);
    listUnitInspection(unit.id, new Date()).then((inspectionRecords) =>
      setInspectionRecords(inspectionRecords),
    );
  }

  const handleEditSingleUnitClick = (unit) => {
    setSelectedUnit(unit);
    setUnitModal(true);
  };

  const handleDeleteUnitModal = (unit) => {
    setSelectedUnit(unit);
    let title = "Confirm Delete Unit '" + unit.name + "'";
    let body = "Are you sure you want to permanently delete this unit?";
    setTitleText(title);
    setTask("Delete Unit");
    setSeverityText("warning");
    setBodyText(body);
    setPositiveText("Delete Unit");
    setNegativeText("Cancel");
    setShowConfirmationModal(true);
  };

  const handleDeleteUnit = () => {
    deleteUnit(selectedUnit).then((response) => {
      if (!isNullUndefined(response)) {
        issueResponseMessage(response);
        setLoading(true);
        getFacility(user.proxyFacility)
          .then((facility) => {
            setFacilityUnits(facility.units);
            setSelectedProperty(facility);
          })
          .finally(() => {
            setLoading(false);
          });
      }
      handleConfirmationClose();
    });
  };

  const handleCourtDelete = () => {
    setLoading(true);
    deleteCourt(selectedCourt.id).then((response) => {
      issueResponseMessage(response);
      getFacilityCourts()
        .then((response) => {
          setCourts(response);
        })
        .finally(() => setLoading(false));
    });
    handleConfirmationClose();
  };

  const handleEditSingleCourtClick = (court) => {
    setSelectedCourt(court);
    setCourtModal(true);
  };

  function handlePropertyModalClose(facilityId) {
    //reload the facility if save or update
    if (!isEmptyString(facilityId) || !isNullUndefined(facilityId)) {
      // TODO: This is not currently working, need to figure out why but not a priority for now
      // if(isNullUndefined(selectedProperty.id)){
      // 	//execute proxy to the new facility if save
      // 	dispatch(clearProxy())
      // 	dispatch({
      // 		type: PROXY_FAC,
      // 		payload: {proxyFacility: facilityId},
      // 	})
      // 	dispatch(
      // 		executeProxy(user.proxyRole, user.proxySubscription, facilityId)
      // 	)
      // }
      getFacility(facilityId).then((facility) => {
        if (!isNullUndefined(facility)) {
          setFacilityUnits(facility.units);
          setSelectedProperty(facility);
        }
      });
    } else {
      //see if there is a facility proxied
      if (!isEmptyString(user.proxyFacility)) {
        getFacility(user.proxyFacility).then((facility) => {
          if (!isNullUndefined(facility)) {
            setFacilityUnits(facility.units);
            setSelectedProperty(facility);
          }
        });
      }
    }
    setPropertyModal(false);
    setSelectedProperty(null);
  }

  const handleViewCourt = (court) => {
    setSelectedCourt(court);
    setCourtViewOpen(true);
  };

  const unitColumns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 230,
      flex: 2.3,
      sortComparator: sortAlphaNum,
    },
    ...(courts.length > 0 && user.services.includes("HOA")
      ? [
          {
            field: "courtName",
            headerName: "Court",
            minWidth: 230,
            flex: 2.3,
          },
        ]
      : []),
    {
      field: "type",
      headerName: "Type",
      minWidth: 300,
      flex: 3,
      valueGetter: (params) => params.value?.name,
      type: "string",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      flex: 1.5,
      valueGetter: (params) =>
        params.value?.name === "Available" ? "Vacant" : params.value?.name,
      type: "string",
    },
    {
      field: "sqft",
      headerName: "Square Meters",
      minWidth: 115,
      flex: 1.15,
      valueFormatter: (params) => formatCurrency(params.value),
      type: "number",
    },
    {
      field: "rent",
      headerName: "Std Rent",
      minWidth: 130,
      flex: 1.3,
      valueFormatter: (params) => formatCurrency(params.value),
      type: "number",
    },
    {
      field: "rentPerSqft",
      headerName: "Rent /SqM",
      minWidth: 115,
      flex: 1.15,
      valueFormatter: (params) => formatCurrency(params.value),
      type: "number",
    },
    {
      field: "beds",
      headerName: "Beds",
      minWidth: 100,
      flex: 1,
      type: "number",
    },
    {
      field: "baths",
      headerName: "Baths",
      minWidth: 100,
      flex: 1,
      type: "number",
    },
    {
      headerName: "Actions",
      width: 100,
      field: "actions",
      type: "actions",
      getActions: (params) => {
        let arr = [];

        arr.push(
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit Unit"
            onClick={() => handleEditSingleUnitClick(params.row)}
            showInMenu
          />,
        );

        arr.push(
          <GridActionsCellItem
            icon={<NoteAdd />}
            label="Add Inspection Record"
            onClick={() => handleInspectUnitClick(params.row)}
            showInMenu
          />,
        );

        arr.push(
          <GridActionsCellItem
            icon={<Visibility />}
            label="View Inspection Records"
            onClick={() => handleViewUnitInspectionsClick(params.row)}
            showInMenu
          />,
        );

        if (
          params?.row?.status?.code !== "LSD" &&
          params?.row?.status?.code !== "OWD"
        ) {
          arr.push(
            <GridActionsCellItem
              sx={{ color: "red" }}
              icon={<Delete sx={{ color: "red" }} />}
              label="Delete Unit"
              onClick={() => handleDeleteUnitModal(params.row)}
              showInMenu
            />,
          );
        }

        return arr;
      },
    },
  ];

  const meterColumns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 230,
      flex: 2.3,
      sortComparator: sortAlphaNum,
    },
    {
      field: "meterType",
      headerName: "Type",
      minWidth: 100,
      flex: 1,
      type: "string",
    },
    {
      field: "broken",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => (params.value ? "Broken" : "Active"),
      type: "string",
    },
    {
      field: "attachedTo",
      headerName: "Attached To",
      minWidth: 100,
      flex: 2,
      type: "string",
    },
    {
      field: "currentMeterReading",
      headerName: "Current Reading",
      minWidth: 115,
      flex: 1,
      valueGetter: (params) => params.value?.amount ?? 0,
      type: "string",
    },
    {
      field: "rateTypeName",
      headerName: "Rate Type",
      minWidth: 100,
      flex: 1,
      type: "string",
    },
    {
      field: "readingFrequencyName",
      headerName: "Reading Freq.",
      minWidth: 100,
      flex: 1,
      type: "string",
    },
  ];

  const courtColumns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 230,
      flex: 2.3,
      sortComparator: sortAlphaNum,
    },
    {
      field: "unitsCount",
      headerName: "Units Count",
      minWidth: 230,
      flex: 2.3,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 230,
      flex: 2.3,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      flex: 1.5,
      valueGetter: (params) => params.value?.name,
      type: "string",
    },
    {
      headerName: "Actions",
      width: 100,
      field: "actions",
      type: "actions",
      getActions: (params) => {
        let arr = [];
        arr.push(
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit Court"
            onClick={() => handleEditSingleCourtClick(params.row)}
            showInMenu
          />,
        );

        arr.push(
          <GridActionsCellItem
            icon={<Visibility />}
            onClick={() => handleViewCourt(params.row)}
            label="View Court"
            showInMenu
          />,
        );

        if (tryParseInt(params?.row?.unitsCount, 1) <= 0) {
          arr.push(
            <GridActionsCellItem
              sx={{ color: "red" }}
              icon={<Delete sx={{ color: "red" }} />}
              label="Delete Court"
              onClick={() => handleDeleteCourtModal(params.row)}
              showInMenu
            />,
          );
        }
        return arr;
      },
    },
  ];

  return (
    <Permit
      roles="BLDIR,BLDMG,CS"
      noPermittedServiceMessage={{
        title: "Access Denied",
        body: (
          <>
            Your current role is not permitted to view this page. <br /> Please
            contact your system admin if you feel this is an error.
          </>
        ),
      }}
    >
      <MainContainer>
        {propertyModal && (
          <PropertyModal
            handlePropertyModalClose={handlePropertyModalClose}
            propertyModal={propertyModal}
            selectedProperty={selectedProperty}
            subscriptionId={subscription.id}
            subscriptionOp={false}
          />
        )}

        {loading ? (
          <ResponsiveRow
            sx={{
              flexDirection: "column",
              flexWrap: "nowrap",
              height: "60vh",
              width: "100%",
              margin: "auto",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress
              sx={{
                fontSize: "1.2rem",
                color: kodi_theme.palette.primary.dark,
                height: "auto",
                margin: "10px auto",
              }}
            />
            <Typography
              variant="body2"
              color="primary.dark"
              textAlign="center"
              sx={{ width: "100%", height: "auto", margin: "10px auto" }}
            >
              Loading, please wait...
            </Typography>
          </ResponsiveRow>
        ) : (
          !isEmptyObject(selectedProperty) && (
            <>
              <TopBarContainer
                container
                sx={{
                  width: { xs: "100%", lg: "80%" },
                  boxShadow: "0 4px 5px 0 rgba(0,0,0,0.5)",
                }}
              >
                <ResponsiveRow
                  sx={{
                    width: { xs: "100%", lg: "20%" },
                    justifyContent: { xs: "center", lg: "flex-start" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 800,
                      margin: "auto",
                      width: "100%",
                      textAlign: "start",
                      padding: "20px",
                    }}
                  >
                    {selectedProperty.name}
                  </Typography>
                </ResponsiveRow>
                <ResponsiveRow
                  // item
                  sx={{
                    flexWrap: { xs: "wrap", lg: "nowrap" },
                    justifyContent: { xs: "center", lg: "flex-end" },
                    width: { xs: "100%", lg: "80%" },
                    padding: 0,
                  }}
                >
                  {/* <Permit roles="BLDIR,SYSAD"></Permit> */}
                  <SplitButton buttons={propertyButtons} />
                  <Permit services="HOA">
                    <SplitButton buttons={courtButtons} />
                  </Permit>
                  {hasUnitSubscription && (
                    <SplitButton buttons={unitsButtons} />
                  )}
                  <SplitButton buttons={inspectionButtons} />
                </ResponsiveRow>
              </TopBarContainer>

              <ResponsiveRow
                sx={{
                  flexDirection: "row",
                  justifyContent: "center",
                  width: "100%",
                  height: "auto",
                  margin: "10px auto",
                }}
              >
                <ResponsiveRow
                  container
                  sx={{
                    width: { xs: "100%", md: "90%" },
                    minHeight: "240px",
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 12px 0 rgba(0,0,0,0.25)",
                    margin: "20px auto",
                    padding: "20px",
                  }}
                >
                  <ResponsiveRow
                    sx={{
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      margin: "auto 20px",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: "18px",
                      }}
                    >
                      Property Information
                    </Typography>
                  </ResponsiveRow>

                  <ResponsiveRow
                    sx={{
                      flexDirection: { lg: "row", xs: "column" },
                      flexWrap: "nowrap",
                      justifyContent: "space-around",
                      alignItems: "flex-start",
                      width: "100%",
                      height: "auto",
                      margin: "0 20px 20px 20px",
                      padding: 0,
                    }}
                  >
                    <ResponsiveRow
                      sx={{
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        width: { lg: "30%", md: "100%", xs: "100%" },
                        height: "100%",
                        padding: "20px",
                        margin: "10px 5px",
                        backgroundColor: kodi_theme.palette.grey[200],
                        borderRadius: "10px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 800,
                          fontSize: "16px",
                          textAlign: "start",
                          color: "#037171",
                          marginBottom: "20px",
                        }}
                      >
                        Basic Information
                      </Typography>

                      <ResponsiveRow
                        sx={{
                          flexDirection: "row",
                          flexWrap: "nowrap",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: { xs: "100%", lg: "90%" },
                          height: "auto",
                          margin: "10px auto",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 700,
                            textAlign: "start",
                            width: { xs: "50%", md: "50%" },
                          }}
                        >
                          Name
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#037171",
                            textAlign: "end",
                          }}
                        >
                          {selectedProperty?.name}
                        </Typography>
                      </ResponsiveRow>
                      <ResponsiveRow
                        sx={{
                          flexDirection: "row",
                          flexWrap: "nowrap",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          width: { xs: "100%", lg: "90%" },
                          height: "auto",
                          margin: "10px auto",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 700,
                            textAlign: "start",
                            width: { xs: "50%", md: "100%" },
                          }}
                        >
                          Number of Units
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#037171",
                            textAlign: "end",
                          }}
                        >
                          {selectedProperty.totalUnits}
                        </Typography>
                      </ResponsiveRow>
                      <ResponsiveRow
                        sx={{
                          flexDirection: "row",
                          flexWrap: "nowrap",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          width: { xs: "100%", lg: "90%" },
                          height: "auto",
                          margin: "10px auto",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 700,
                            textAlign: "start",
                            width: { xs: "50%", md: "100%" },
                          }}
                        >
                          Occupancy (%)
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#037171",
                            textAlign: "end",
                          }}
                        >
                          {selectedProperty.occupancy}
                        </Typography>
                      </ResponsiveRow>
                    </ResponsiveRow>
                    <ResponsiveRow
                      sx={{
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        justifyContent: "flex-start",
                        alignItems: "flex-end",
                        width: { lg: "70%", md: "100%", xs: "100%" },
                        height: "100%",
                        padding: "20px",
                        margin: "10px 5px",
                        backgroundColor: kodi_theme.palette.grey[200],
                        borderRadius: "10px",
                      }}
                    >
                      <Typography
                        color="primary.dark"
                        fontWeight={800}
                        textAlign="start"
                        sx={{
                          width: "100%",
                          marginBottom: "20px",
                        }}
                      >
                        Payment Information
                      </Typography>
                      <Accordion
                        sx={{ marginBottom: 1, width: "100%", boxShadow: 0 }}
                        expanded={accordionOpen}
                        onChange={() => setAccordionOpen(!accordionOpen)}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="header"
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: kodi_theme.palette.primary.dark,
                            }}
                          >
                            {"Notes"}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          This payment information will be sent out on the
                          invoices so that customers can make payments using the
                          appropriate service. <br />
                          <Permit services="HOA">
                            When pay to invoice/Charge is turned on, payment
                            received would be used to offset the invoice/Charge
                            in reference. When hide balance brought forward is
                            turned on, previously unpaid sum would be hidden on
                            the invoice/Charge.
                          </Permit>
                        </AccordionDetails>
                      </Accordion>
                      <DetailsContainer
                        sx={{
                          margin: "0",
                          width: "100%",
                          padding: 0,
                        }}
                      >
                        <DetailsColumn
                          sx={{
                            marginTop: 0,
                            width: "40%",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                          }}
                        >
                          {selectedProperty?.facilityPayInfo?.useMpesa && (
                            <ResponsiveRow
                              sx={{
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                width: { xs: "100%", lg: "90%" },
                                margin: "0 auto",
                                paddingBottom: "0",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  textAlign: "start",
                                  width: { xs: "50%", md: "100%" },
                                }}
                              >
                                {`MPESA ${user.services.includes("BLWTR") ? "Till" : "Paybill"}`}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#037171",
                                  textAlign: "end",
                                }}
                              >
                                {
                                  selectedProperty?.facilityPayInfo
                                    ?.mpesaPaybill
                                }
                              </Typography>
                            </ResponsiveRow>
                          )}

                          {selectedProperty?.facilityPayInfo?.useMpesa && (
                            <ResponsiveRow
                              sx={{
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                width: { xs: "100%", lg: "90%" },
                                margin: "0 auto",
                                paddingBottom: "0",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  textAlign: "start",
                                  width: { xs: "50%", md: "100%" },
                                }}
                              >
                                MPESA Shortcode
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#037171",
                                  textAlign: "end",
                                }}
                              >
                                {
                                  selectedProperty?.facilityPayInfo
                                    ?.mpesaBusinessShortcode
                                }
                              </Typography>
                            </ResponsiveRow>
                          )}
                        </DetailsColumn>


                        {selectedProperty?.facilityPayInfo?.useCustomPay && (
                            <DetailsColumn
                                sx={{
                                  marginTop: 0,
                                  width: "70%",
                                  alignItems: "flex-end",
                                  justifyContent: "flex-start",
                                }}
                            >
                              <ResponsiveRow
                                  sx={{
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    width: { xs: "100%", lg: "90%" },
                                    margin: "0 auto",
                                    paddingBottom: "0",
                                  }}
                              >
                                <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: 700,
                                      textAlign: "start",
                                      width: { xs: "50%", md: "100%" },
                                    }}
                                >
                                  Custom Pay Instructions
                                </Typography>
                                <Typography
                                    sx={{
                                      fontSize: "14px",
                                      color: "#037171",
                                      textAlign: "start",
                                    }}
                                >
                                  {
                                    selectedProperty?.facilityPayInfo
                                        ?.customPayInstruction
                                  }
                                </Typography>
                              </ResponsiveRow>
                            </DetailsColumn>
                        )}

                        {selectedProperty?.facilityPayInfo?.useBankAccount && (
                          <DetailsColumn
                            sx={{
                              marginTop: 0,
                              width: "60%",
                              alignItems: "flex-end",
                              justifyContent: "flex-start",
                            }}
                          >
                            <ResponsiveRow
                              sx={{
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                width: { xs: "100%", lg: "90%" },
                                margin: "0 auto",
                                paddingBottom: "0",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  textAlign: "start",
                                  width: { xs: "50%", md: "100%" },
                                }}
                              >
                                Bank Account Name
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#037171",
                                  textAlign: "end",
                                }}
                              >
                                {
                                  selectedProperty?.facilityPayInfo
                                    ?.bankAccountName
                                }
                              </Typography>
                            </ResponsiveRow>
                            <ResponsiveRow
                              sx={{
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                width: { xs: "100%", lg: "90%" },
                                height: "auto",
                                margin: "0 auto",
                                paddingBottom: "0",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  textAlign: "start",
                                  width: { xs: "50%", md: "50%" },
                                }}
                              >
                                Bank Branch
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#037171",
                                  textAlign: "end",
                                }}
                              >
                                {
                                  selectedProperty?.facilityPayInfo
                                    ?.bankAccountBranch
                                }
                              </Typography>
                            </ResponsiveRow>
                            <ResponsiveRow
                              sx={{
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                width: { xs: "100%", lg: "90%" },
                                margin: "10px auto",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  textAlign: "start",
                                  width: { xs: "50%", md: "100%" },
                                }}
                              >
                                Account No
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#037171",
                                  textAlign: "end",
                                }}
                              >
                                {
                                  selectedProperty?.facilityPayInfo
                                    ?.bankAccountNumber
                                }
                              </Typography>
                            </ResponsiveRow>
                          </DetailsColumn>
                        )}
                      </DetailsContainer>
                    </ResponsiveRow>
                  </ResponsiveRow>
                  <Permit roles={"SYSAD,BLDIR"}>
                    <Typography
                      fontWeight={800}
                      textAlign="start"
                      variant="h5"
                      color="primary.dark"
                      sx={{
                        margin: "10px 30px 5px 30px",
                      }}
                    >
                      Services
                    </Typography>
                    <ResponsiveRow
                      sx={{
                        width: "100%",
                        height: "200px",
                        overflowX: "hidden",
                        overflowY: "auto",
                        margin: "0 20px",
                        padding: { xs: 0, lg: "10px" },
                      }}
                    >
                      {selectedProperty.subscriptionServices?.length > 0 &&
                        selectedProperty.subscriptionServices.map(
                          (service, i) => (
                            <PropertySubscriptionServiceItem
                              key={i}
                              data={service}
                            />
                          ),
                        )}
                    </ResponsiveRow>
                  </Permit>
                </ResponsiveRow>
              </ResponsiveRow>
              {selectionModel.length > 1 && (
                <Permit roles="BLDIR,SYSAD" services="PREMIUM,HOA,CORE,LEAN">
                  <ResponsiveRow
                    sx={{
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                      height: "auto",
                      margin: { xs: "20px 10px", lg: "40px auto 20px auto" },
                      padding: "10px 20px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      boxShadow: "1px 1px 15px 0 rgba(0,0,0,0.5)",
                    }}
                  >
                    <ResponsiveRow
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                        width: { xs: "100%", lg: "50%" },
                        height: "100%",
                        padding: { xs: "10px 0", lg: "auto 10px" },
                      }}
                    >
                      {" "}
                      <Typography variant="h5" fontWeight={700}>
                        Bulk Units Operations
                      </Typography>
                    </ResponsiveRow>
                    <ResponsiveRow
                      sx={{
                        flexDirection: { xs: "column", lg: "row" },
                        flexWrap: "nowrap",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: 0,
                        width: { xs: "100%", lg: "50%" },
                        height: "100%",
                        margin: "auto",
                      }}
                    >
                      <TopBarContainedBrandButton
                        sx={{
                          width: { xs: "100%", lg: "200px", height: "auto" },
                        }}
                      >
                        Edit {selectionModel.length} Units
                      </TopBarContainedBrandButton>
                    </ResponsiveRow>
                  </ResponsiveRow>
                </Permit>
              )}

              <Permit services="PREMIUM, HOA, CORE, LEAN, MAINT">
                {facilityUnits.length > 0 && (
                  <>
                    <Typography variant="h3" sx={{ width: "100%" }}>
                      FACILITY UNITS
                    </Typography>
                    <MuiDataGrid
                      dataGridColumns={unitColumns}
                      dataGridRows={facilityUnits}
                      serverPagination={false}
                      handleSelectedRows={setSelectionModel}
                      currentSelectionModel={selectionModel}
                      loading={loading}
                      height="60vh"
                      totalRows={facilityUnits.length}
                    />
                  </>
                )}
              </Permit>
              <Permit services="METER">
                {meters.length > 0 && (
                  <>
                    <Typography variant="h3" sx={{ width: "100%" }}>
                      FACILITY METERS
                    </Typography>
                    <MuiDataGrid
                      dataGridColumns={meterColumns}
                      dataGridRows={meters}
                      serverPagination={false}
                      handleSelectedRows={setSelectionModel}
                      currentSelectionModel={selectionModel}
                      loading={loading}
                      height="60vh"
                      totalRows={meters.length}
                    />
                  </>
                )}
              </Permit>
              <br />
              <Permit services="HOA">
                {courts.length > 0 && (
                  <>
                    <Typography variant="h3" sx={{ width: "100%" }}>
                      COURTS
                    </Typography>
                    <MuiDataGrid
                      dataGridColumns={courtColumns}
                      dataGridRows={courts}
                      serverPagination={false}
                      handleSelectedRows={setSelectionModel}
                      currentSelectionModel={selectionModel}
                      loading={loading}
                      totalRows={courts.length}
                    />
                  </>
                )}
              </Permit>
            </>
          )
        )}

        {/*INSPECT MODAL*/}
        {task === "Inspect" && (
          <Inspections
            openModal={InspectModal}
            closeModal={() => setInspectModal(false)}
            contract={contract}
            inspectionItem={inspect}
          />
        )}

        <ViewInspections
          openModal={ViewModal}
          closeModal={() => {
            setViewModal(false);
            setInspectionRecords([]);
          }}
          contract={contract}
          inspectionItem={inspect}
          inspectionRecords={inspectionRecords}
        />
      </MainContainer>

      {unitModal && (
        <UnitModal
          setUnitModal={setUnitModal}
          unitModal={unitModal}
          unit={selectedUnit}
        />
      )}

      {courtViewOpen && (
        <ViewCourtModal
          viewOpen={courtViewOpen}
          court={selectedCourt}
          cancel={() => setCourtViewOpen(false)}
        />
      )}

      {courtModal && (
        <CourtModal
          setCourtModal={setCourtModal}
          courtModal={courtModal}
          court={selectedCourt}
        />
      )}

      {showConfirmationModal && (
        <ConfirmationModal
          showConfirmationModal={showConfirmationModal}
          handleConfirmationClose={handleConfirmationClose}
          title={titleText}
          severity={severityText}
          body={bodyText}
          positiveText={positiveText}
          negativeText={negativeText}
          positiveAction={
            task === "Delete Unit" ? handleDeleteUnit : handleCourtDelete
          }
          negativeAction={handleConfirmationClose}
        />
      )}
    </Permit>
  );
}
